export const LabelsWidget = (props: React.PropsWithChildren) => props.children;
